import classNames from 'classnames'

export function Rank({ className, ...props }) {
  return <span className={classNames('Rank', className)} {...props} />
}
